import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'
import { VariableWidthContentLayout } from 'src/resources/layouts/VariableWidthContentLayout'

export const DevRoutes = ({ match: { path } }: RouteComponentProps) => (
  <Switch>
    <Route render={() => <VariableWidthContentLayout />} path={`${path}/layout`} />
    <Redirect to='/' />
  </Switch>
)
